/**
 * Client Routes Plugin - Handles journey navigation from Echo
 * Receives route launch requests from the desktop Echo app
 */

import { EchoConnection, EchoPlugin } from '../types'

// EchoClient will be imported from data-access when we move it there
interface EchoClientLike {
  emit(event: string, data: unknown): void
}

export interface ClientRoutesPluginOptions {
  /**
   * Callback to handle route navigation
   * @param path - The route path to navigate to (e.g., "/cash/p2p/send")
   */
  onNavigate?: (path: string) => void
}

export class ClientRoutesPlugin implements EchoPlugin {
  readonly id = 'com.cash.echo.plugin.clientroutes'
  private connection: EchoConnection | null = null
  private echoClient: EchoClientLike
  private onNavigateCallback?: (path: string) => void

  constructor(echoClient: EchoClientLike, options: ClientRoutesPluginOptions = {}) {
    this.echoClient = echoClient
    this.onNavigateCallback = options.onNavigate
  }

  onConnect(connection: EchoConnection): void {
    this.connection = connection
  }

  onDisconnect(): void {
    this.connection = null
  }

  onDesktopPluginActive(): void {
    // Desktop plugin became active
  }

  onDesktopPluginInactive(): void {
    // Desktop plugin became inactive
  }

  onDataReceived(data: string): void {
    try {
      const event = JSON.parse(data)

      // Handle launch event from desktop
      if (event.name === 'launch' && event.metadata?.path) {
        const path = event.metadata.path
        this.handleLaunch(path)
      }
    } catch (error) {
      this.echoClient.emit('error', error as Error)
    }
  }

  /**
   * Set the navigation callback
   */
  setOnNavigate(callback: (path: string) => void): void {
    this.onNavigateCallback = callback
  }

  /**
   * Private: Handle route launch request
   */
  private handleLaunch(path: string): void {
    if (this.onNavigateCallback) {
      this.onNavigateCallback(path)
    }
  }
}
